export const calculateBMI = (weight: string, height: string) => {
    if (!weight || !height) {
      return { vki: '', obesityStatus: '' };
    }
  
    const weightValue = parseFloat(weight.replace(",", "."));
    const heightValue = parseFloat(height) / 100;
    const calculatedVki = (weightValue / (heightValue * heightValue)).toFixed(2);
  
    let obesityStatus = '';
    const vkiNumber = parseFloat(calculatedVki);
    if (vkiNumber < 18.5) {
      obesityStatus = 'Zayıf';
    } else if (vkiNumber < 25) {
      obesityStatus = 'Normal Kilolu';
    } else if (vkiNumber < 30) {
      obesityStatus = 'Fazla Kilolu';
    } else if (vkiNumber < 35) {
      obesityStatus = '1. Derece Obezite';
    } else if (vkiNumber < 41) {
      obesityStatus = '2. Derece Obezite';
    } else if (vkiNumber < 51) {
      obesityStatus = '3. Derece Obezite / Morbid Obezite';
    } else {
      obesityStatus = 'Süper Obezite';
    }
  
    return { vki: calculatedVki, obesityStatus };
  };
  